import { render, staticRenderFns } from "./CandidateProfileLink.vue?vue&type=template&id=c3f740a6&"
import script from "./CandidateProfileLink.vue?vue&type=script&lang=js&"
export * from "./CandidateProfileLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports